
export const UploadActionTypes = {
    TOGGLE_UPLOAD_PAGE_OPEN : 'TOGGLE_UPLOAD_PAGE_OPEN',
}